module.exports = "https://99designs-start-assets.imgix.net/js/21ccf0b1aa243db0cdf4b440b02e1e9e.png";